import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Hello } from "./compends/task1/moodletask/hello world/hellomoodle";
import { Card } from "./compends/task1/moodletask/card/card";
import { League } from "./compends/task1/moodletask/super league/league";
import { Social } from "./compends/task1/moodletask/social button/social";
import { Noti } from "./compends/task1/moodletask/notifacation/noti";
import { Menu } from "./compends/task1/menu";
import { Tech } from "./compends/task1/moodletask/techcard/techcard";
import { Login } from "./compends/task1/moodletask/login/login";
import { Counter } from "./compends/task1/moodletask/incresedecres/incresedecrese";
import { Banana } from "./compends/task1/moodletask/banana/banana";
import { Smile } from "./compends/task1/moodletask/feedback/smilefeedback";
import { Heart } from "./compends/task1/moodletask/feedback/heartfeedback";
import { Sample1 } from "./jsontask/jsontask2";
import { Sample2 } from "./jsontask/jsontask2.1";
import { Overall } from "./compends/protfolio/overallprotfolio";
import { Promenu } from "./compends/protfolio/protfoliomenu";
import { Proabout } from "./compends/protfolio/protfolioabout/protfolioabout";
import { Procerfi } from "./compends/protfolio/protfoliocerfication/protfoliocerfi";
import { Profront } from "./compends/protfolio/protfoliohome/protfoliofront";
import { Portedu } from "./compends/protfolio/protfolioEducation/portfolioedu";
import { Porcentect } from "./compends/protfolio/proconect/procontent";
import { Porwork } from "./compends/protfolio/portfoliomywork/portfoliowork";
import { Photoshop } from "./compends/protfolio/portfoliomywork/photoshop/photoshop";
import { Coraldraw, Css } from "./compends/protfolio/portfoliomywork/css/css";
import { Coral } from "./compends/protfolio/portfoliomywork/coreldraw/coreldraw";
import { Html } from "./compends/protfolio/portfoliomywork/html/html";
import { Sample } from "./jsontask/jsontask1";
import { Datefunction } from "./compends/task1/moodletask/Datefunction/Datefunction";
import { Weatherindia } from "./compends/task1/moodletask/weather api/weather";
import { Profilemenu } from "./jsontask/jsontask17";
import { Parallx } from "./compends/traning/carosul/Paralax";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={[
              <Promenu />,
              <Profront />,
              <Proabout />,
              <Procerfi />,
              <Portedu />,
              <Porwork />,
              <Porcentect />,
            ]}
          />
          <Route path="/Hello" element={[<Menu />, <Hello />]} />
          <Route path="/Card" element={[<Menu />, <Card />]} />
          <Route path="/League" element={[<Menu />, <League />]} />
          <Route path="/Social" element={[<Menu />, <Social />]} />
          <Route path="/Noti" element={[<Menu />, <Noti />]} />
          <Route path="/Login" element={[<Menu />, <Login />]} />
          <Route path="/Tech" element={[<Menu />, <Tech />]} />
          <Route path="/Count" element={[<Menu />, <Counter />]} />
          <Route path="/Fruit" element={[<Menu />, <Banana />]} />
          <Route path="/Smile" element={[<Menu />, <Smile />]} />
          <Route path="/Heart" element={[<Menu />, <Heart />]} />
          <Route path="/Sample2/:id" element={[<Menu />, <Sample2 />]} />
          <Route path="/Sample1" element={[<Menu />, <Sample1 />]} />
          <Route path="/Sample" element={[<Menu />, <Sample />]} />
          <Route path="/Datefunction" element={[<Menu />, <Datefunction />]} />
          <Route path="/Weatherindia" element={[<Menu />, <Weatherindia />]} />
          <Route path="/Profilemenu" element={[<Menu />, <Profilemenu />]} />

          <Route path="/gd/Photoshop" element={<Photoshop />} />
          <Route path="/Css" element={<Css />} />
          <Route path="/Coral" element={<Coral />} />
          <Route path="/Html" element={<Html />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
